import { Component, OnInit ,Inject,EventEmitter} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../notification.service';
@Component({
  selector: 'app-delete-admin',
  templateUrl: './delete-admin.component.html',
  styleUrls: ['./delete-admin.component.scss']
})
export class DeleteAdminComponent implements OnInit {
isemit = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,private snack:MatSnackBar ,private notification:NotificationService,private service:CommonService,private dialogRef: MatDialogRef<DeleteAdminComponent>,public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  rideDelete(){
    this.service.dltadmin(this.data)
    .subscribe((res:any)=>{
      if(res.message == "Success"){
        // this.snack.open("Deleted successfully",'',{
        //   duration:1000,
        //  verticalPosition:'top',
        //  horizontalPosition: 'end',

        // })
        this.notification.showInfo("Deleted succcessfully",'')
        this.isemit.emit(true)
        this.dialogRef.close();
        
      }else{
        alert("something went wrong");
      }
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
